import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { ReactComponent as Cash } from "../assets/money.svg";
import { ReactComponent as Credit } from "../assets/credit.svg";
import { ReactComponent as Debit } from "../assets/debit.svg";
import { ReactComponent as Bookeey } from "../assets/bookeey.svg";
import { ReactComponent as POS } from "../assets/pos.svg";
import { ReactComponent as Friends } from "../assets/friends.svg";
import { ReactComponent as Tamara } from "../assets/tamara.svg";
import { ReactComponent as Tabby } from "../assets/tabby.svg";
import { ReactComponent as Star } from "../../PromotionalStoreFront/assets/star.svg";
import { ReactComponent as Visa } from "../assets/visa.svg";
import { ReactComponent as Mastercard } from "../assets/mastercard.svg";
import { ReactComponent as Deema } from "../assets/deema.svg";
import BenefitTransfer from "../assets/benefit.png";
import BenefitGateway from "../assets/benefit-gateway.png";
import { connect } from "react-redux";
import FormHelperText from "@material-ui/core/FormHelperText";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ShareCartDrawer from "./ShareCartDrawer";
import walletImage from "../assets/wallet.png";
import { MenuList } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import { CheckCircleOutline, RadioButtonUnchecked } from "@material-ui/icons";
import { ReactComponent as Apple } from "../../Profile/assets/apple.svg";

import UseCustomerWallet from "./UseCustomerWallet";
import UseCustomerPoints from "./UseCustomerPoints";
import GooglePay from "../assets/google-pay.png";
import SamsungPay from "../assets/samsung-pay.png";
import instance from "../../../store/actions/instance";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getCurrencyIso } from "../../../Helpers/currencyConverter";
const isAppleDevice = () => {
  return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
};

class PaymentMethod extends Component {
  state = {
    shareCartDrawerOpen: false,

    tamaraData: null,
    tamaraLoading: false,

    tabbyLoading: false,
    tabbyAvailable: false,
  };

  fetchTamaraAvailability = async () => {
    const { total, customerContact } = this.props;
    if (!total || !customerContact?.phone) return;
    try {
      this.setState({ tamaraLoading: true });
      const res = await instance.post("/fetch_tamara_availability/", {
        phone: customerContact.phone,
        amount: total,
        currency: this.props.currency.selected,
      });

      if (res.data.success && res.data.data) {
        this.setState({ tamaraData: res.data.data });
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ tamaraLoading: false });
  };

  fetchTabbyAvailability = async () => {
    const { total, customerContact } = this.props;
    if (!total || !customerContact?.phone) return;
    try {
      this.setState({ tabbyLoading: true });
      const res = await instance.post("/fetch_tabby_availability/", {
        phone: customerContact.phone,
        amount: total,
        currency: this.props.currency.selected,
        name: customerContact.name,
        email: customerContact.email,
      });

      if (res.data.success) {
        this.setState({ tabbyAvailable: true });
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ tabbyLoading: false });
  };

  tamaraPaymentTypeConverter = (payment_type, installments) => {
    if (payment_type === "PAY_BY_INSTALMENTS") {
      return `tamara-${String(installments)}-installments`;
    }
    return "tamara"; // PAY_NOW
  };

  shouldEnableCash = () => {
    if (!this.props.settings.enable_cash || !this.props.settings.allow_cash)
      return false;
    if (this.props.isPickup && this.props.settings.enable_cash_pickup)
      return true;
    else if (!this.props.isPickup && this.props.settings.enable_cash_delivery)
      return true;
    return false;
  };
  shouldEnableOfflinePayments = () => {
    if (this.props.fromWallet) return false;
    if (
      !this.props.settings.is_branch_based_ordering &&
      this.props.address?.country
    ) {
      if (
        this.props.countries.find((c) => c.id == this.props.address.country)
          ?.enable_offline_payments
      )
        return true;
      else return false;
    } else if (
      this.props.settings.is_branch_based_ordering &&
      !!this.props.branch.bdc &&
      this.props.branch.bdc !== -1 &&
      !this.props.branch.isPickup
    ) {
      if (
        this.props.countries.find(
          (c) =>
            c.id ===
            this.props.branch_delivery_charges.find(
              (bdc) => bdc.id === this.props.branch.bdc
            )?.country_id
        )?.enable_offline_payments
      ) {
        return true;
      } else return false;
    } else if (
      this.props.settings.is_branch_based_ordering &&
      this.props.isPickup &&
      this.props.branch.branch
    ) {
      if (!this.props.countries?.length) return true;
      if (
        this.props.countries.find(
          (c) =>
            c.id ===
            this.props.branches.find((b) => b.id === this.props.branch.branch)
              ?.country_id
        )?.enable_offline_payments
      ) {
        return true;
      } else return false;
    }
    return true;
  };

  checkPaymentMethod = (paymentMethod) => {
    const { settings, user, total, smart_promos, vat, appliedPromo } =
      this.props;

    switch (paymentMethod) {
      case "cash": {
        if (
          !(
            this.shouldEnableOfflinePayments() &&
            this.shouldEnableCash() &&
            !this.props.cartHasCreditOnly &&
            !(this.props.isGift && settings.disable_cash_for_gift) &&
            !(
              settings.enable_cash_below_certain_amount &&
              settings.cash_below_certain_amount > 0 &&
              settings.cash_below_certain_amount <= this.props.total
            ) &&
            !smart_promos?.some((promo) => promo.applyForCash == false)
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "tap": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_tap &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "tap_v2": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            (settings.enable_tap_v2 || settings.enable_tap_v3_debit) &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "tap_v2_credit": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_tap_v3_credit &&
            !!settings.tap_pk &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "hesabe": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_hesabe &&
            settings.enable_hesabe_whitelabeled_methods &&
            settings.currency_iso === "KWD" &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "hesabe-cc": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_hesabe &&
            settings.enable_hesabe_credit &&
            settings.enable_hesabe_whitelabeled_methods &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "hesabe-gateway": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_hesabe &&
            settings.enable_hesabe_gateway &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "myfatoorah": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_myfatoorah &&
            (!settings.is_myfatoorah_direct ||
              settings.enable_myfatoorah_debit) &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "myfatoorah-cc": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_myfatoorah &&
            settings.is_myfatoorah_direct &&
            settings.enable_myfatoorah_credit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "bookey": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_bookey &&
            settings.enable_bookey_debit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "tahseeel": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_tahseeel &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "ebutler": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ebutler_payment &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "gatee": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_gatee &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "sadad": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_sadad &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "sadad_kw": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_sadad_kw &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "tpay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_tpay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "knet": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_knet &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "benefit": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_benefit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "ottu": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ottu &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "ottu-cc": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ottu &&
            settings.enable_ottu_credit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "ottu_v2": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ottu_v2 &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "credimax": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_credimax &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "eazypay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_eazypay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "afs": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_afs &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "apgateway": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ap_gateway &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay &&
            (!settings.upay_whitelabel || settings.upay_enable_debit) &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay_v2": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay_v2 &&
            (!settings.upay_v2_whitelabel || settings.upay_v2_enable_debit) &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay-cc": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay &&
            settings.upay_whitelabel &&
            settings.upay_enable_credit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay_v2-cc": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay_v2 &&
            settings.upay_v2_whitelabel &&
            settings.upay_v2_enable_credit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay_v2-apple-pay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay_v2 &&
            settings.upay_v2_whitelabel &&
            settings.upay_v2_enable_apple_pay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay_v2-apple-pay-knet": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay_v2 &&
            settings.upay_v2_whitelabel &&
            settings.upay_v2_enable_apple_pay_knet &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay_v2-google-pay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay_v2 &&
            settings.upay_v2_whitelabel &&
            settings.upay_v2_enable_google_pay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "upay_v2-samsung-pay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_upay_v2 &&
            settings.upay_v2_whitelabel &&
            settings.upay_v2_enable_samsung_pay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "bookey-cc": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_bookey &&
            settings.enable_bookey_credit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "bookey-wallet": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_bookey &&
            settings.enable_bookey_wallet &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "bookey-apple-pay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_bookey &&
            settings.enable_bookey_apple_pay &&
            !this.props.cartHasCashOnly &&
            (isAppleDevice() || !window.location.hostname.includes("naif"))
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "casheer": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_casheer &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "paytabs": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_paytabs &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      case "paymob": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_paymob &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      case "payza": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_payza &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "ecom": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ecom &&
            !settings.enable_ecom_knet &&
            !settings.enable_ecom_credit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      case "ecom-knet": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ecom &&
            settings.enable_ecom_knet &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      case "ecom-credit": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_ecom &&
            settings.enable_ecom_credit &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      case "payza-cc": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_payza &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      case "paystack": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_paystack &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "kod": {
        if (
          !(
            settings.enable_knet_on_delivery &&
            this.shouldEnableOfflinePayments() &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "benefit-transfer": {
        if (!settings.enable_benefit_transfer) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "wallet": {
        if (
          !(
            settings.enable_payments &&
            settings.enable_wallet &&
            settings.enable_wallet_staff &&
            this.shouldEnableOfflinePayments() &&
            this.props.user &&
            !this.props.cartHasCashOnly &&
            user?.wallet > total
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "loyalty points": {
        if (
          settings.enable_payments &&
          settings.enable_loyalty_points &&
          settings.enable_loyalty_points_staff &&
          settings.enable_loyalty_points_payment &&
          this.shouldEnableOfflinePayments() &&
          this.props.user &&
          !this.props.cartHasCashOnly
        ) {
          const avaialblePoints =
            user?.points - (appliedPromo?.loyalty_points_cost || 0);

          const loyaltyPointsValue =
            Math.floor(
              avaialblePoints / settings.loyalty_points_to_money_threshold
            ) * settings.loyalty_points_to_money_conversion_rate;
          if (loyaltyPointsValue < total + this.props.vat) {
            this.props.setPaymentMethod("none");
            this.props.handleChange("none");
            this.props.setUseCustomerPoints(false, false);
          }
        } else {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "share": {
        if (
          !(
            settings.enable_sharing_carts_staff &&
            settings.enable_sharing_carts &&
            !!this.props.abandonedCartID
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "nbk": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_nbk &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "tap_v2_apple_pay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_tap_v3_apple_pay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "tap_v2_deema": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_tap_v3_deema &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }
      case "myfatoorah_apple_pay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_myfatoorah_apple_pay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      case "myfatoorah_google_pay": {
        if (
          !(
            settings.enable_online_payments &&
            settings.enable_payments &&
            settings.enable_myfatoorah_google_pay &&
            !this.props.cartHasCashOnly
          )
        ) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
        break;
      }

      default:
        this.props.setPaymentMethod("none");
        this.props.handleChange("none");
        break;
    }
  };

  componentDidMount() {
    if (!this.props.fromWallet) {
      this.checkPaymentMethod(this.props.paymentMethod);
      if (this.props.settings.enable_tamara) this.fetchTamaraAvailability();
      if (this.props.settings.enable_tabby) this.fetchTabbyAvailability();
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.fromWallet) {
      if (
        this.props.paymentMethod === "cash" &&
        this.props.smart_promos?.some((promo) => promo.applyForCash == false)
      ) {
        this.checkPaymentMethod(this.props.paymentMethod);
      }

      if (this.props.total !== prevProps.total) {
        if (this.props.settings.enable_tamara) this.fetchTamaraAvailability();
        if (this.props.settings.enable_tabby) this.fetchTabbyAvailability();
      }
    }
  }
  render() {
    const {
      language,
      settings,
      isPickup,
      address,
      countries,
      branch,
      branch_delivery_charges,
      branches,
      vat,
      user,
      total,
      fromWallet,
      themeColor,
      cartHasCashOnly,
      cartHasCreditOnly,
      useCustomerWallet,
      setUserCustomerWallet,
      useCustomerPoints,
      setUseCustomerPoints,
      appliedPromo,
    } = this.props;

    const avaialblePoints =
      user?.points - (appliedPromo?.loyalty_points_cost || 0);

    const loyaltyPointsNeeded = Math.ceil(
      (total + vat) *
        (settings.loyalty_points_to_money_threshold /
          settings.loyalty_points_to_money_conversion_rate)
    );
    const debitCardText =
      language == "english"
        ? settings.custom_texts.debit_card
        : settings.custom_texts.debit_card_ar;
    const creditCardText =
      language == "english"
        ? settings.custom_texts.credit_card
        : settings.custom_texts.credit_card_ar;
    const debitCreditText =
      language == "english"
        ? `${settings.custom_texts.debit_card}/${settings.custom_texts.credit_card}`
        : `${settings.custom_texts.credit_card_ar}/${settings.custom_texts.debit_card_ar}`;
    const cashText =
      language === "english"
        ? settings.custom_texts.cash
        : settings.custom_texts.cash_ar;

    const applePayText =
      language == "english"
        ? settings.custom_texts.apple_pay
        : settings.custom_texts.apple_pay_ar;

    const deemaText =
      language == "english"
        ? settings.custom_texts.deema
        : settings.custom_texts.deema_ar;

    const checkIfCashOnly = () => {
      if (
        settings.enable_cash &&
        settings.allow_cash &&
        settings.enable_online_payments &&
        settings.enable_payments &&
        !this.props.fromWallet
      ) {
        if (cartHasCashOnly) return true;
        return !cartHasCreditOnly;
      }
      return true;
    };
    const checkIfCreditOnly = () => {
      if (
        settings.enable_cash &&
        settings.allow_cash &&
        settings.enable_online_payments &&
        settings.enable_payments &&
        !this.props.fromWallet
      ) {
        if (cartHasCreditOnly) return true;
        return !cartHasCashOnly;
      }
      return true;
    };
    const checkIfCashBelowCertainAmount = () => {
      const condition =
        settings.enable_cash &&
        settings.allow_cash &&
        settings.enable_cash_below_certain_amount &&
        settings.cash_below_certain_amount > 0 &&
        settings.cash_below_certain_amount <= total;

      if (this.props.paymentMethod === "cash") {
        if (condition) {
          this.props.setPaymentMethod("none");
          this.props.handleChange("none");
        }
      }
      return !condition;
    };
    const currency = getCurrencyIso(settings, language);
    return (
      <>
        {settings.enable_payments &&
          settings.enable_wallet &&
          settings.enable_wallet_staff &&
          this.shouldEnableOfflinePayments() &&
          user &&
          user.wallet > 0 &&
          settings.enable_wallet_partials && (
            <UseCustomerWallet
              useCustomerWallet={useCustomerWallet}
              setUserCustomerWallet={setUserCustomerWallet}
            />
          )}

        {user &&
          settings.enable_payments &&
          settings.enable_loyalty_points &&
          settings.enable_loyalty_points_staff &&
          settings.enable_loyalty_points_payment &&
          this.shouldEnableOfflinePayments() &&
          checkIfCreditOnly() &&
          !(
            avaialblePoints < settings.loyalty_points_to_money_threshold ||
            (!settings.enable_wallet_partials &&
              loyaltyPointsNeeded > avaialblePoints)
          ) && (
            <UseCustomerPoints
              useCustomerPoints={useCustomerPoints}
              setUseCustomerPoints={setUseCustomerPoints}
              orderTotal={total + vat}
            />
          )}

        {!(useCustomerPoints && this.props.paymentMethod == "loyalty points") &&
          (!useCustomerWallet ||
            user?.wallet < total ||
            !settings.enable_wallet_partials) && (
            <div
              style={
                this.props.fromWallet
                  ? { marginTop: 30, width: "100%" }
                  : { marginTop: 30 }
              }
            >
              <ShareCartDrawer
                open={this.state.shareCartDrawerOpen}
                close={() => this.setState({ shareCartDrawerOpen: false })}
              />
              <p
                className="box-title"
                style={{
                  textAlign: language === "arabic" ? "right" : "left",
                  direction: language === "arabic" ? "rtl" : "ltr",
                }}
              >
                {language == "english" ? "Payment Method" : "طريقة الدفع"}{" "}
                {settings.enable_myfatoorah &&
                  settings.currency_iso === "JOD" && (
                    <>
                      <Visa width="30" height="30" />{" "}
                      <Mastercard width="30" height="30" />{" "}
                    </>
                  )}
                {settings.enable_sharing_carts_staff &&
                  settings.enable_sharing_carts &&
                  !!this.props.abandonedCartID && (
                    <span
                      style={{
                        fontWeight: "bold",
                        color: this.props.themeColor,
                        float: language === "arabic" ? "left" : "right",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        this.setState({ shareCartDrawerOpen: true })
                      }
                    >
                      {language === "arabic"
                        ? "شخص آخر سيدفع؟"
                        : "someone else paying?"}
                    </span>
                  )}
              </p>

              <div
                className={`w-100 mx-0 mb-3 ${
                  !fromWallet && "border-top border-bottom"
                }`}
                style={{ backgroundColor: "white" }}
              >
                <MenuList
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                >
                  {this.shouldEnableCash() &&
                    this.shouldEnableOfflinePayments() &&
                    checkIfCashOnly() &&
                    !(this.props.isGift && settings.disable_cash_for_gift) &&
                    checkIfCashBelowCertainAmount() &&
                    !this.props.smart_promos?.some(
                      (promo) => promo.applyForCash == false
                    ) && (
                      <MenuItem
                        onClick={() => this.props.handleChange("cash")}
                        value={"cash"}
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "cash"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {cashText}
                        </span>

                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto float-left pl-2"
                          }
                        >
                          <Cash width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_tap &&
                    checkIfCreditOnly() && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tap")}
                        value="tap"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tap"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_tap_v2 &&
                    checkIfCreditOnly() && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tap_v2")}
                        value="tap_v2"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tap_v2"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_tap_v3_debit &&
                    checkIfCreditOnly() && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tap_v2")}
                        value="tap_v2"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tap_v2"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_tap_v3_credit &&
                    checkIfCreditOnly() &&
                    !!settings.tap_pk && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tap_v2_credit")}
                        value="tap_v2_credit"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tap_v2_credit"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_tap_v3_apple_pay &&
                    checkIfCreditOnly() && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("tap_v2_apple_pay")
                        }
                        value="tap_v2_apple_pay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tap_v2_apple_pay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {applePayText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Apple width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_tap_v3_deema &&
                    checkIfCreditOnly() && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tap_v2_deema")}
                        value="tap_v2_deema"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tap_v2_deema"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {deemaText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Deema width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_hesabe &&
                    settings.enable_hesabe_whitelabeled_methods &&
                    checkIfCreditOnly() &&
                    settings.currency_iso === "KWD" && (
                      <MenuItem
                        onClick={() => this.props.handleChange("hesabe")}
                        value="hesabe"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "hesabe"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_hesabe &&
                    settings.enable_hesabe_whitelabeled_methods &&
                    checkIfCreditOnly() &&
                    settings.enable_hesabe_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("hesabe-cc")}
                        value="hesabe-cc"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "hesabe-cc"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_hesabe &&
                    settings.enable_hesabe_gateway &&
                    checkIfCreditOnly() && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("hesabe-gateway")
                        }
                        value="hesabe-gateway"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "hesabe-gateway"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {language === "arabic"
                            ? settings.custom_texts.pay_online_ar
                            : settings.custom_texts.pay_online}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_myfatoorah &&
                    checkIfCreditOnly() &&
                    (!settings.is_myfatoorah_direct ||
                      settings.enable_myfatoorah_debit) && (
                      <MenuItem
                        onClick={() => this.props.handleChange("myfatoorah")}
                        value="myfatoorah"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "myfatoorah"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {settings.is_myfatoorah_direct
                            ? debitCardText
                            : debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_myfatoorah &&
                    settings.is_myfatoorah_direct &&
                    checkIfCreditOnly() &&
                    settings.enable_myfatoorah_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("myfatoorah-cc")}
                        value="myfatoorah-cc"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "myfatoorah-cc"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_myfatoorah &&
                    settings.is_myfatoorah_direct &&
                    checkIfCreditOnly() &&
                    settings.enable_myfatoorah_apple_pay && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("myfatoorah_apple_pay")
                        }
                        value="myfatoorah_apple_pay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "myfatoorah_apple_pay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {applePayText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Apple width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_myfatoorah &&
                    settings.is_myfatoorah_direct &&
                    checkIfCreditOnly() &&
                    settings.enable_myfatoorah_google_pay && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("myfatoorah_google_pay")
                        }
                        value="myfatoorah_google_pay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "myfatoorah_google_pay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {"Google Pay"}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <img src={GooglePay} width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_bookey &&
                    settings.enable_bookey_debit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("bookey")}
                        style={{
                          backgroundColor:
                            this.props.value === "bookey"
                              ? "rgba(0,0,0,0.08)"
                              : "",
                        }}
                        value="bookey"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "bookey"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_tahseeel && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tahseeel")}
                        value="tahseeel"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tahseeel"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_ebutler_payment && (
                      <MenuItem
                        onClick={() => this.props.handleChange("ebutler")}
                        value="ebutler"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "ebutler"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_gatee && (
                      <MenuItem
                        onClick={() => this.props.handleChange("gatee")}
                        value="gatee"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "gatee"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_sadad && (
                      <MenuItem
                        onClick={() => this.props.handleChange("sadad")}
                        value="sadad"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "sadad"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_sadad_kw && (
                      <MenuItem
                        onClick={() => this.props.handleChange("sadad_kw")}
                        value="sadad_kw"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "sadad_kw"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_tpay && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tpay")}
                        value="tpay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tpay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_knet && (
                      <MenuItem
                        onClick={() => this.props.handleChange("knet")}
                        value="knet"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "knet"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_benefit_transfer && (
                    <MenuItem
                      onClick={() =>
                        this.props.handleChange("benefit-transfer")
                      }
                      value="benefit-transfer"
                      dir={language == "english" ? "ltr" : "rtl"}
                    >
                      <Checkbox
                        inputProps={{ "aria-label": "primary checkbox" }}
                        icon={<RadioButtonUnchecked />}
                        checkedIcon={
                          <CheckCircleOutline style={{ color: themeColor }} />
                        }
                        checked={this.props.value === "benefit-transfer"}
                        color="primary"
                      />
                      <span
                        className={
                          language == "english"
                            ? "float-left pl-2"
                            : "float-right"
                        }
                        style={{ lineHeight: 2, verticalAlign: "middle" }}
                      >
                        {language == "english" ? "Benefit Pay" : "تحويل بينيفت"}
                      </span>
                      <span
                        className={
                          language == "english"
                            ? "ml-auto float-right"
                            : "mr-auto pl-2 float-left"
                        }
                      >
                        <img src={BenefitTransfer} width="30" height="30" />
                      </span>
                    </MenuItem>
                  )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_benefit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("benefit")}
                        value="benefit"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "benefit"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <img src={BenefitGateway} width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_ottu && (
                      <MenuItem
                        onClick={() => this.props.handleChange("ottu")}
                        value="ottu"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "ottu"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_ottu &&
                    checkIfCreditOnly() &&
                    settings.enable_ottu_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("ottu-cc")}
                        value="ottu-cc"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "ottu-cc"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_ottu_v2 && (
                      <MenuItem
                        onClick={() => this.props.handleChange("ottu_v2")}
                        value="ottu_v2"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "ottu_v2"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_credimax && (
                      <MenuItem
                        onClick={() => this.props.handleChange("credimax")}
                        value="credimax"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "credimax"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_eazypay && (
                      <MenuItem
                        onClick={() => this.props.handleChange("eazypay")}
                        value="eazypay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "eazypay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_afs && (
                      <MenuItem
                        onClick={() => this.props.handleChange("afs")}
                        value="afs"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "afs"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_ap_gateway && (
                      <MenuItem
                        onClick={() => this.props.handleChange("apgateway")}
                        value="apgateway"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "apgateway"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_nbk && (
                      <MenuItem
                        onClick={() => this.props.handleChange("nbk")}
                        value="nbk"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "nbk"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_upay &&
                    (!settings.upay_whitelabel ||
                      settings.upay_enable_debit) && (
                      <MenuItem
                        onClick={() => this.props.handleChange("upay")}
                        value="upay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "upay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_upay_v2 &&
                    (!settings.upay_v2_whitelabel ||
                      settings.upay_v2_enable_debit) && (
                      <MenuItem
                        onClick={() => this.props.handleChange("upay_v2")}
                        value="upay_v2"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "upay_v2"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_upay &&
                    checkIfCreditOnly() &&
                    settings.upay_whitelabel &&
                    settings.upay_enable_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("upay-cc")}
                        value="upay-cc"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "upay-cc"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_upay_v2 &&
                    checkIfCreditOnly() &&
                    settings.upay_v2_whitelabel &&
                    settings.upay_v2_enable_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("upay_v2-cc")}
                        value="upay_v2-cc"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "upay_v2-cc"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_upay_v2 &&
                    checkIfCreditOnly() &&
                    settings.upay_v2_whitelabel &&
                    settings.upay_v2_enable_apple_pay && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("upay_v2-apple-pay")
                        }
                        value="upay_v2-apple-pay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "upay_v2-apple-pay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {applePayText}{" "}
                          {language === "arabic"
                            ? "(بطاقة ائتمان)"
                            : "(Credit Card)"}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Apple width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_upay_v2 &&
                    checkIfCreditOnly() &&
                    settings.upay_v2_whitelabel &&
                    settings.upay_v2_enable_apple_pay_knet && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("upay_v2-apple-pay-knet")
                        }
                        value="upay_v2-apple-pay-knet"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={
                            this.props.value === "upay_v2-apple-pay-knet"
                          }
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {applePayText}{" "}
                          {language === "arabic" ? "(كي نت)" : "(KNET)"}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Apple width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_upay_v2 &&
                    checkIfCreditOnly() &&
                    settings.upay_v2_whitelabel &&
                    settings.upay_v2_enable_google_pay && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("upay_v2-google-pay")
                        }
                        value="upay_v2-google-pay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "upay_v2-google-pay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {"Google Pay"}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <img src={GooglePay} width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_upay_v2 &&
                    checkIfCreditOnly() &&
                    settings.upay_v2_whitelabel &&
                    settings.upay_v2_enable_samsung_pay && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("upay_v2-samsung-pay")
                        }
                        value="upay_v2-samsung-pay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "upay_v2-samsung-pay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {"Samsung Pay"}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <img src={SamsungPay} width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    settings.enable_bookey &&
                    checkIfCreditOnly() &&
                    settings.enable_bookey_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("bookey-cc")}
                        value="bookey-cc"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "bookey-cc"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_bookey &&
                    settings.enable_bookey_wallet && (
                      <MenuItem
                        onClick={() => this.props.handleChange("bookey-wallet")}
                        value="bookey-wallet"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "bookey-wallet"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {language == "english"
                            ? "Bookeey Wallet"
                            : "محفظة بوكي"}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Bookeey width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_bookey &&
                    settings.enable_bookey_apple_pay &&
                    (isAppleDevice() ||
                      !window.location.hostname.includes("naif")) && (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange("bookey-apple-pay")
                        }
                        value="bookey-apple-pay"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "bookey-apple-pay"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          Apple Pay
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Apple width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_payza && (
                      <MenuItem
                        onClick={() => this.props.handleChange("payza")}
                        value="payza"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "payza"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_payza && (
                      <MenuItem
                        onClick={() => this.props.handleChange("payza-cc")}
                        value="payza-cc"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "payza-cc"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_paytabs && (
                      <MenuItem
                        onClick={() => this.props.handleChange("paytabs")}
                        value="paytabs"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "paytabs"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_paymob && (
                      <MenuItem
                        onClick={() => this.props.handleChange("paymob")}
                        value="paymob"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "paymob"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_ecom_knet && (
                      <MenuItem
                        onClick={() => this.props.handleChange("ecom-knet")}
                        value="ecom-knet"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "ecom-knet"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_ecom_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("ecom-credit")}
                        value="ecom-credit"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "ecom-credit"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {creditCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Credit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_ecom &&
                    !settings.enable_ecom_knet &&
                    !settings.enable_ecom_credit && (
                      <MenuItem
                        onClick={() => this.props.handleChange("ecom")}
                        value="ecom"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "ecom"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_casheer && (
                      <MenuItem
                        onClick={() => this.props.handleChange("casheer")}
                        value="casheer"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "casheer"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCreditText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_paystack && (
                      <MenuItem
                        onClick={() => this.props.handleChange("paystack")}
                        value="paystack"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "paystack"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {debitCardText}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Debit width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_knet_on_delivery &&
                    this.shouldEnableOfflinePayments() &&
                    checkIfCreditOnly() && (
                      <MenuItem
                        onClick={() => this.props.handleChange("kod")}
                        value="kod"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "kod"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {/*{language == "english" ? "KNet Machine" : "جهاز كي نت"}*/}
                          {language == "english"
                            ? settings.custom_texts.pay_with_knet_machine
                            : settings.custom_texts.pay_with_knet_machine_ar}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <POS width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_tamara &&
                    this.state.tamaraLoading && (
                      <div className="mt-1 mb-3">
                        <CircularProgress
                          style={{
                            width: 25,
                            height: 25,
                            color: themeColor,
                          }}
                        />
                      </div>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_tabby &&
                    this.state.tabbyLoading && (
                      <div className="mt-1 mb-3">
                        <CircularProgress
                          style={{
                            width: 25,
                            height: 25,
                            color: themeColor,
                          }}
                        />
                      </div>
                    )}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_tamara &&
                    this.state.tamaraData &&
                    this.state.tamaraData.map((po) => (
                      <MenuItem
                        onClick={() =>
                          this.props.handleChange(
                            this.tamaraPaymentTypeConverter(
                              po.payment_type,
                              po.instalment
                            )
                          )
                        }
                        value={this.tamaraPaymentTypeConverter(
                          po.payment_type,
                          po.instalment
                        )}
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={
                            this.props.value ===
                            this.tamaraPaymentTypeConverter(
                              po.payment_type,
                              po.instalment
                            )
                          }
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{
                            lineHeight: 2,
                            verticalAlign: "middle",
                            width: "100%",
                            whiteSpace: "initial",
                            textAlign: language === "arabic" ? "right" : "left",
                          }}
                        >
                          {language == "english"
                            ? po.description_en
                            : po.description_ar}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Tamara width="40" height="40" />
                        </span>
                      </MenuItem>
                    ))}

                  {settings.enable_online_payments &&
                    settings.enable_payments &&
                    checkIfCreditOnly() &&
                    settings.enable_tabby &&
                    this.state.tabbyAvailable && (
                      <MenuItem
                        onClick={() => this.props.handleChange("tabby")}
                        value={"tabby"}
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "tabby"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{
                            lineHeight: 2,
                            verticalAlign: "middle",
                            width: "100%",
                            whiteSpace: "initial",
                            textAlign: language === "arabic" ? "right" : "left",
                          }}
                        >
                          {language == "english"
                            ? "Pay in 4. No interest, no fees."
                            : "قسّمها على 4. بدون أي فوائد، أو رسوم."}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Tabby width="40" height="40" />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_payments &&
                    settings.enable_wallet &&
                    settings.enable_wallet_staff &&
                    this.shouldEnableOfflinePayments() &&
                    checkIfCreditOnly() &&
                    !settings.enable_wallet_partials &&
                    user && (
                      <MenuItem
                        onClick={() => this.props.handleChange("wallet")}
                        disabled={user.wallet < total + vat}
                        value="wallet"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "wallet"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {(language == "arabic" && "المحفظة ") || "Wallet "}
                          <span style={{ fontSize: 12 }}>
                            (
                            {`${user.wallet.toFixed(
                              settings?.currency_decimals
                            )}
                ${currency}`}
                            )
                          </span>
                          {user.wallet < total + vat && (
                            <span
                              style={{ fontSize: 12, color: "#D30707" }}
                              className="bold"
                            >
                              {`
                ${
                  language == "english"
                    ? "You don't have enough credit"
                    : "ليس لديك رصيد كافي"
                }`}
                            </span>
                          )}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <img
                            src={walletImage}
                            width="30"
                            height="30"
                            alt="wallet"
                          />
                        </span>
                      </MenuItem>
                    )}

                  {settings.enable_sharing_carts_staff &&
                    settings.enable_sharing_carts &&
                    !!this.props.abandonedCartID && (
                      <MenuItem
                        onClick={() => this.props.handleChange("share")}
                        value="share"
                        dir={language == "english" ? "ltr" : "rtl"}
                      >
                        <Checkbox
                          inputProps={{ "aria-label": "primary checkbox" }}
                          icon={<RadioButtonUnchecked />}
                          checkedIcon={
                            <CheckCircleOutline style={{ color: themeColor }} />
                          }
                          checked={this.props.value === "share"}
                          color="primary"
                        />
                        <span
                          className={
                            language == "english"
                              ? "float-left pl-2"
                              : "float-right"
                          }
                          style={{ lineHeight: 2, verticalAlign: "middle" }}
                        >
                          {language == "english"
                            ? "Send checkout to a friend"
                            : "ارسال الطلب الى صديق"}
                        </span>
                        <span
                          className={
                            language == "english"
                              ? "ml-auto float-right"
                              : "mr-auto pl-2 float-left"
                          }
                        >
                          <Friends width="30" height="30" />
                        </span>
                      </MenuItem>
                    )}
                </MenuList>
                <FormHelperText
                  error={this.props.paymentError}
                  className={"mx-auto ".concat(
                    language == "english" ? "text-left" : "text-right"
                  )}
                  style={{
                    width: "92%",
                    display: this.props.paymentError == false && "none",
                    fontSize: 13,
                    marginBottom: 15,
                  }}
                >
                  {language == "english"
                    ? "Please select a payment method"
                    : "الرجاء اختيار طريقة الدفع"}
                </FormHelperText>

                {this.props.value === "benefit-transfer" && (
                  <p
                    style={{
                      color: "#CC0000",
                      textAlign: "center",
                      background: "pink",
                      margin: "auto",
                      borderRadius: 5,
                      fontWeight: "bold",
                      padding: "5px 20px",
                      marginTop: 20,
                      fontSize: 14,
                      width: "fit-content",
                      marginBottom: 10,
                    }}
                  >
                    <InfoOutlinedIcon
                      style={{ position: "relative", left: -8 }}
                    />
                    {language == "english"
                      ? "You will be provided with an IBAN for transfer"
                      : "سيتم تقديم ايبان للتحويل"}
                  </p>
                )}
              </div>
            </div>
          )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    address: state.customers.address,
    countries: state.store.store.all_countries || state.store.store.countries,
    branch: state.branch,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branches: state.store.store.branches,
    user: state.auth.user,
    abandonedCartID: state.abandonedCart.id,
    themeColor: state.store.store.settings.dark || "#0099cc",
    paymentMethod: state.cart.payment_method,
    cartHasCashOnly: state.cart.cash_only_items > 0,
    cartHasCreditOnly: state.cart.credit_only_items > 0,
    isGift: state.promise.isGift,
    appliedPromo: state.cart.promos,
    customerContact: state.customers?.customerContact,
    smart_promos: state.cart.smart_promos,
    currency: state.currency,
  };
};

export default connect(mapStateToProps)(PaymentMethod);
